// Mock data for CLawdFactory landing page
// This file simulates API responses when REACT_APP_USE_MOCK=true

// NOTE: LiveActivity uses these labels to display steps.
// Keep labels consistently capitalized.
export const STEPS = [
  { key: 'IDEATION', label: 'Clawd generates a unique meme concept' },
  { key: 'BRAND', label: 'Creating name' },
  { key: 'DESIGN', label: 'Creating visual' },
  { key: 'COPY', label: 'Writing launch' },
  { key: 'DEPLOY', label: 'Deploy' },
  { key: 'ANNOUNCE', label: 'Announce' },
  { key: 'MONITOR', label: 'Monitor' },
  { key: 'BUYBACK', label: 'Executing ETH' },
];

export const mockStatus = {
  current_action: 'Creating visual',
  global_progress: 35,
  current_step: 'DESIGN',
  steps: [
    { name: 'IDEATION', status: 'done', progress: 100 },
    { name: 'BRAND', status: 'done', progress: 100 },
    { name: 'DESIGN', status: 'running', progress: 62 },
    { name: 'COPY', status: 'pending', progress: 0 },
    { name: 'DEPLOY', status: 'pending', progress: 0 },
    { name: 'ANNOUNCE', status: 'pending', progress: 0 },
    { name: 'MONITOR', status: 'pending', progress: 0 },
    { name: 'BUYBACK', status: 'pending', progress: 0 },
  ],
  next_cycle_eta_seconds: 2847,
};

export const mockStats = {
  tokens_launched_24h: 4,
  tokens_launched_7d: 28,
  tokens_launched_all: 156,
  buybacks_eth_24h: 1.25,
  buybacks_eth_7d: 8.73,
  buybacks_eth_all: 54.32,
  treasury_spent_24h: 0.42,
  treasury_spent_7d: 2.8,
  uptime_pct: 99.7,
  last_cycle_duration_seconds: 847,
};

export const mockLaunches = [
  {
    name: 'Moon Pepe',
    ticker: 'MPEP',
    contract_url: 'https://basescan.org/token/0xabc123',
    timestamp: '2025-08-15T14:32:00Z',
  },
  {
    name: 'Based Chad',
    ticker: 'BCHAD',
    contract_url: 'https://basescan.org/token/0xdef456',
    timestamp: '2025-08-15T12:15:00Z',
  },
  {
    name: 'Wojak Supreme',
    ticker: 'WSUP',
    contract_url: 'https://basescan.org/token/0xghi789',
    timestamp: '2025-08-15T09:45:00Z',
  },
  {
    name: 'Degen Lord',
    ticker: 'DLORD',
    contract_url: 'https://basescan.org/token/0xjkl012',
    timestamp: '2025-08-14T22:18:00Z',
  },
];

export const mockLastBuyback = {
  tx_hash: '0x7f8c9d0e1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d',
  amount_eth: 0.85,
  timestamp: '2025-08-15T13:45:00Z',
};
